import { Theme, createTheme } from "@mui/material";

export const muiLightTheme: Theme = createTheme({
  palette: {
    mode: "light",
    background: {
      default: "#f7f7f7",
    },
    text: {
      primary: "#303030",
      secondary: "#303030",
    },
  },
  components: {
    MuiFormLabel: {
      styleOverrides: {
        asterisk: { color: "red" },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: "#000000",
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          "& .MuiDataGrid-iconButtonContainer": {
            visibility: "visible",
          },
          "& .MuiDataGrid-sortIcon": {
            color: "#000000",
            opacity: "inherit !important",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "1px solid #E0E0E0 ",
            fontFamily: "Honeywell Sans Web",
          },
          "& .MuiDataGrid-withBorderColor": {
            borderColor: "#E0E0E0 ",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "800",
          },
          "& .MuiDataGrid-root": {
            fontFamily: "Honeywell Sans Web",
          },
          "& .MuiDataGrid-columnHeaders": {
            fontFamily: "Honeywell Sans Web",
          },
          "& .MuiDataGrid-cellCheckbox": {
            "& .Mui-disabled": {
              "& svg": {
                color: "#BDBDBD !important",
              },
            },
          },
        },
        footerContainer: {
          "&.MuiDataGrid-footerContainer": {
            // minHeight: "5vh",
            // height: "5vh",
            justifyContent: "center",
            paddingLeft: ".875rem",
          },
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: "1.2rem",
          color: "#000000",
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginTop: "0",
          fontSize: "0.7rem",
          color: "#FF6F67 !important",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-input": {
            fontSize: "0.75rem",
            fontWeight: 500,
            fontFamily: "Honeywell Sans Web",
            fontStyle: "normal",
          },
          "& .MuiFormLabel-root": {
            fontSize: "13px",
            fontWeight: 500,
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          height: "2rem",
          borderColor: "rgba(160,160,160,var(--tw-border-opacity))",
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          paddingTop: 0,
          paddingBottom: 0,
          backgroundColor: "#272727",
          "& .MuiPaginationDropdown": {
            fontSize: "13px",
            fontWeight: 500,
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: { padding: "4px" },
      },
    },
    MuiTreeItem: {
      styleOverrides: {
        label: {
          fontSize: "0.7rem",
          fontWeight: 500,
          fontFamily: "Honeywell Sans Web",
        },
      },
    },

    MuiToolbar: {
      styleOverrides: {
        root: {
          backgroundColor: "#f7f7f7",
          color: "#000000",
          "@media (min-width: 600px)": {
            minHeight: "6vh",
            paddingLeft: "1.55vh",
          },
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        displayedRows: {
          fontSize: "0.875rem",
          fontFamily: "Honeywell Sans Web",
        },
        toolbar: {
          background: "#FFFFFF",
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        option: {
          height: "2rem",
          fontSize: "0.875rem",
          gap: "0.5rem",
        },
        listbox: {
          fontSize: "0.875rem",
          paddingTop: "0px",
          paddingBottom: "0px",
          backgroundColor: "#ffffff",
        },
        root: {
          "& .MuiOutlinedInput-root": {
            padding: "0px",
            paddingRight: "5px",
          },
          "& ..MuiAutocomplete-tag": {
            margin: "0px",
            height: "2rem",
          },
          "& .MuiAutocomplete-input::placeholder": {
            color: "#303030 !important",
            fontWeigth: "800",
          },
        },
        endAdornment: {
          // up/down chevron icon
          button: {
            marginLeft: "1rem",
            width: "1rem",
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "#232323",
          color: "white",
          borderRadius: ".2rem",
          padding: ".7rem",
          fontSize: ".875rem",
          ".MuiTooltip-arrow::before": {
            //pseudo-element for the arrow
            backgroundColor: "#232323",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        list: {
          "&.MuiList-root": {
            backgroundColor: "#ffffff",
          },
        },
      },
    },
  },
} as any);
